module.exports = __webpack_public_path__ + "media/images/taxjar-7ad35f70a20471317fc14e01cf9e5b20.svg";